import type { StripeError } from '@stripe/stripe-js';

export class ThreeDSAuthorizationError extends Error {
  stripeError: StripeError;
  constructor(message: string, stripeError: StripeError) {
    super(message);
    this.stripeError = stripeError;
  }
}

export const StripeErrorCodes = {
  PAYMENT_INTENT_AUTHENTICATION_FAILURE:
    'payment_intent_authentication_failure',
} as const;
